import styled from 'styled-components';
import themeColors from '../assets/styles/themeColors';
import { variables } from '../assets/styles/variables';

export const ParagraphRegular = styled.p`
  font-size: ${variables.typography.p.regular.fontSize};
  line-height: ${variables.typography.p.regular.lineHeight};
  color: ${({ color }) => color || themeColors.colorTextSecondary};
  font-weight: ${({ weight }) => weight || 'normal'};
`;

export const ParagraphRegularSub = styled(ParagraphRegular)`
  color: ${themeColors.colorTextXLLight};
`;

export const ParagraphNormal = styled.p`
  font-size: ${variables.typography.p.normal.fontSize};
  line-height: ${variables.typography.p.normal.lineHeight};
  color: ${({ color }) => color || themeColors.colorTextSecondary};
  font-weight: ${({ weight }) => weight || 400};
  ${({ isDone }) => isDone && `color: ${themeColors.colorTextGrey};`}
`;

export const ParagraphNormalSub = styled(ParagraphNormal)`
  color: ${({ color }) => color ?? themeColors.colorTextGrey};
`;
